module.exports = __webpack_public_path__ + "img/mono-square.345c4b94.svg";